import { useBreakpoints, useRequest, useView } from '@10000/react'
import { InputScreen, useShell, useStack } from '../../layout'
import { Avatar, Body, Box, Button, H3 } from '../../widgets'
import { OrganisationCompany } from './'
import { Teams } from '../team'

export const PartnerOnboardConfirmation = ({ active, organisationId }) => {
  const { push } = useStack()
  const { organisations } = useView('tenant')
  const request = useRequest('tenant')
  const { mobile } = useBreakpoints()

  const { avatar, name } = organisations.find(x => x.id === organisationId)

  useShell({ active, mode: 'narrow logo' })

  return (
    <InputScreen fade fadeColour="blue" pb={32}>
      <Box column gap={mobile ? 16 : 24}>
        <Box column gap={8} alignItems="center">
          <Avatar mode="company" index={avatar} size={mobile ? 'medium' : 'large'} />
          <H3>{name} is set up!</H3>
          <Body align="center">
            You have successfully set up your organisation. What would like to do next?
          </Body>
        </Box>

        <Box className="fit-button-to-container" gap={16} column fullWidth>
          <Button onClick={() => push(Teams, { props: { organisationId } })}>
            Add another team
          </Button>
          <Button onClick={() => push(OrganisationCompany)}>
            Set up a new organisation
          </Button>
          <Button light onClick={() => request('teamSetupComplete')}>
            Finish set up
          </Button>
        </Box>
      </Box>
    </InputScreen>
  )
}